import { lazy } from 'react';
import type { Routes } from '@/@types/routes';
import {
  CONTEXT_SETTINGS_PREFIX_PATH,
  CONTEXT_SETTINGS_ROUTES,
} from '@/constants/route.constant.ts';

const contextSettingsRoutes: Routes = [
  // {
  //   key: 'contextSettings.property.details',
  //   path: `${CONTEXT_SETTINGS_PREFIX_PATH}/${CONTEXT_SETTINGS_ROUTES.PROPERTY_DETAILS}`,
  //   component: lazy(() => import('@/views/context-settings/PropertyDetails')),
  //   authority: ['SUPERADMIN', 'ADMIN'],
  //   meta: {
  //     header: {
  //       title: 'Property details',
  //       contained: true,
  //     },
  //     footer: false,
  //   },
  // },
  {
    key: 'contextSettings.services.list',
    path: `${CONTEXT_SETTINGS_PREFIX_PATH}/${CONTEXT_SETTINGS_ROUTES.SERVICES_LIST}`,
    component: lazy(() => import('@/views/context-settings/Services/Services')),
    authority: ['SUPERADMIN', 'ADMIN'],
  },
  {
    key: 'contextSettings.services.create',
    path: `${CONTEXT_SETTINGS_PREFIX_PATH}/${CONTEXT_SETTINGS_ROUTES.SERVICES_CREATE}`,
    component: lazy(() => import('@/views/context-settings/Services/ServiceCreate')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Add service',
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: 'contextSettings.services.edit',
    path: `${CONTEXT_SETTINGS_PREFIX_PATH}/${CONTEXT_SETTINGS_ROUTES.SERVICES_EDIT}/:id`,
    component: lazy(() => import('@/views/context-settings/Services/ServiceEdit')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Edit service',
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: 'contextSettings.departments.list',
    path: `${CONTEXT_SETTINGS_PREFIX_PATH}/${CONTEXT_SETTINGS_ROUTES.DEPARTMENTS_LIST}`,
    component: lazy(() => import('@/views/context-settings/Departments/Departments')),
    authority: ['SUPERADMIN', 'ADMIN'],
  },
  {
    key: 'contextSettings.departments.create',
    path: `${CONTEXT_SETTINGS_PREFIX_PATH}/${CONTEXT_SETTINGS_ROUTES.DEPARTMENTS_CREATE}`,
    component: lazy(() => import('@/views/context-settings/Departments/DepartmentCreate')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Add department',
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: 'contextSettings.departments.edit',
    path: `${CONTEXT_SETTINGS_PREFIX_PATH}/${CONTEXT_SETTINGS_ROUTES.DEPARTMENTS_EDIT}/:id`,
    component: lazy(() => import('@/views/context-settings/Departments/DepartmentEdit')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Edit department',
        contained: true,
      },
      footer: false,
    },
  },
];

export default contextSettingsRoutes;
